import React from 'react'
import Header from '../../Header/Header'
import Footer from '../../Footer/Footer'

// images
import hero from "./Images/hero.svg";


// icons
import { FaHome } from "react-icons/fa";
import { IoIosArrowForward } from "react-icons/io";

import BoardofDirectors from './BoardofDirectors';

const Directors = () => {
    return (
      <div>
          <Header/>
          <div
        className="w-full h-[451px] relative hidden"
        style={{
          backgroundImage: `url(${hero})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
        }}
      >
        <div className="absolute inset-0  bg-[#02256D] bg-opacity-85 "></div>
        <div className="relative z-10 w-[100%] h-[100%] flex flex-col  py-[20px] justify-center items-center">
          <h2 className=" text-center sm:text-[61px] text-[48px] text-[#FDBC12] font-bold ">
          Directors
          </h2>
          <p className="text-[20px] text-[#CBD5E0] text-center lg:w-[80%]">
          It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here.
          </p>
          <div className="flex bg-[#1E2A3A] border border-[#465468] rounded-md py-2 px-4 mt-4 text-[#64748B]">
            <a
              className="flex gap-x-3 items-center mr-3 active:text-[#F1F4F9]"
              href="/"
            >
              {" "}
              <FaHome />
              Home
            </a>
            <a
              className="flex  gap-x-3 items-center mr-3 active:text-[#F1F4F9]"
              href="/directors"
            >
              {" "}
              <IoIosArrowForward />
              Directors            </a>
          
          </div>
        </div>
      </div>
      <BoardofDirectors/>
          <Footer/>
      </div>
    )
  }
  
  export default Directors